import Head from 'next/head';
import TermsContent from '@/content/Info/Terms';

function Terms() {
  return (
    <>
      <Head>
        <title>Terms & Conditions</title>
      </Head>
      <TermsContent />
    </>
  );
}

export default Terms;
